<template>
  <ankh-list :padding="0" :show-btn-group="!isPlain" v-bind="$attrs">
    <template #search-form>
      <el-form-item :label="$t('分度值')">
        <el-input :placeholder="$t('分度值')" clearable v-model="searchForm.scale" />
      </el-form-item>
      <el-form-item :label="$t('协议代码')">
        <el-input :placeholder="$t('协议代码')" clearable v-model="searchForm.protocolCode" />
      </el-form-item>
      <el-form-item :label="$t('创建日期')">
        <date-time-range-picker
            :start-time.sync="searchForm.startCreateTime"
            :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{$t('查询')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #btn-group>
      <el-button size="small" type="primary" @click="handleShowFormDialog()">{{$t('新增')}}</el-button>
      <el-button size="small" type="primary" @click="$emit('export')">{{$t('导出')}}</el-button>
      <el-button size="small" type="danger" @click="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          :search-params="searchForm"
          @query="loadList"
          @selection-change="selection = $event"
          :data="tableData">
        <el-table-column type="selection" width="50" />
        <el-table-column type="index" :label="$t('序号')" width="50" />
        <el-table-column :label="$t('分度值')" prop="scale" />
        <el-table-column :label="$t('协议代码')">
          <template v-slot="{row}">
            <div class="flex" style="column-gap: 6px" v-if="row.protocolCode">
              <el-link :underline="false" type="primary">{{ row.protocolCode || "" }}</el-link>
              <i class="el-icon-copy-document" @click="handleCopy(row)" id="copyBtn" :data-clipboard-text="row.protocolCode" />
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('创建日期')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('备注')" prop="remark" />
        <el-table-column :label="$t('操作')" v-if="!isPlain">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="handleShowFormDialog(row)">{{$t('编辑')}}</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <!-- 新增/编辑-->
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="handleReset">
        <template #title>
          <h4>{{ isEdit ? $t('编辑') : $t('新增') }}</h4>
        </template>

        <el-form label-width="auto" ref="form" :rules="rules" :model="formData">
          <el-form-item :label="$t('分度值')" prop="scale">
            <el-input :placeholder="$t('分度值')" v-model="formData.scale" @blur.stop="buildProtocol" />
          </el-form-item>
          <el-form-item :label="$t('协议')" prop="protocolCode">
            <el-input :placeholder="$t('协议')" v-model="formData.protocolCode" />
          </el-form-item>
          <el-form-item :label="$t('备注')" prop="remark">
            <el-input :placeholder="$t('备注')" type="textarea" :rows="4" v-model="formData.remark" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button type="primary" @click="handleAddOrEditSubmit">{{$t('确认')}}</el-button>
          <el-button @click="handleReset">{{$t('重置')}}</el-button>
        </template>
      </el-dialog>
    </template>

  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import {copyText} from "@/utils/copy";
import {resetEmpty} from "@/utils/common";
import {getProtocol} from "@/utils/protocol";
import AnkhList from "@/components/list/AnkhList.vue";
import {exportExcel} from "@/utils/export";

export default {
  name: "PrecisionAdjust",
  components: {AnkhList, DateTimeRangePicker, TableList},
  props: {
    isPlain: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      tableData: [],
      searchForm: {
        scale: null
      },
      selection: [],
      showDialog: false,
      formData: {
        scale: null,
        protocolCode: null,
        remark: null,
      },
      rules: {
        scale: [
          {required: true, message: this.$t('请输入分度值'), trigger: 'blur'},
        ],
        protocolCode: {required: true, message: this.$t('请输入协议代码'), trigger: 'change'}
      },
      isEdit: false,
      currentRow: {}
    }
  },
  methods: {
    // 导出
    handleExport() {
      const codes = this.selection.map(item => item.code);
      exportExcel(codes, this.$api.common.exportPrecisionAdjust);
    },

    // 构建协议
    buildProtocol() {
      try {
        const val = this.formData.scale;
        const prefix = "ee130100"
        this.formData.protocolCode = getProtocol(prefix, val, 2);
      } catch (e) {
        console.error("生成协议失败", e);
      }
    },

    // 查询
    handleSearch() {
      if(this.searchForm.scale && typeof this.searchForm.scale !== 'number') {
        this.$message.warning(this.$t('分度值必须为数字'));
        return;
      }
      this.$refs.list.handleSearch();
    },

    // 复制
    handleCopy() {
      copyText("#copyBtn");
    },

    // 新增\编辑
    handleAddOrEditSubmit() {
      this.$refs.form.validate(async valid => {
        if(!valid) return;
        try {
          let data = {...this.formData};
          const action = this.$api.precisionAdjust[this.isEdit ? 'update' : 'add'];
          if(this.isEdit) {
            data = Object.assign(this.currentRow, data);
            delete data.createTime;
            delete data.updateTime;
          }
          await request(action, data);
          this.$message.success(this.$t('操作成功'));
          this.showDialog = false;
          this.$refs.list.handleRequest();
        } catch (e) {
          console.log(e);
        }
      })
    },
    // 重置
    handleReset() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    },


    handleShowFormDialog(row) {
      if(row) {
        this.currentRow = {...row};
        for (const key in this.formData) {
          this.formData[key] = row[key];
        }
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.showDialog = true;
    },

    async handleBatchDelete() {
      try {
        const codes = this.selection.map(i => i.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(this.$api.precisionAdjust.batchDelete, codes, {isJson: true}, {message: this.$t('您现在正在进行批量删除操作, 是否继续?')});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.precisionAdjust.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async loadList(params, setTotal) {
      try {
        const res = await request(this.$api.precisionAdjust.list, params);
        this.tableData = res.precisionAdjusts;
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    }
  },
  watch: {
    selection: {
      handler(list) {
        const codes = list.map(i => i.code);
        this.$emit("select", {precisionAdjustCodes: codes});
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
